export const FILE_SIZE = {
  MB: 1024 * 1024
};
